<template>
    <div>
        <v-bottom-sheet v-model="dialogBackupData" persistent v-if="dialogBackupData">
        <!-- <v-dialog v-model="dialogBackupData" v-if="dialogBackupData" persistent no-click-animation transition="slide-y-transition" max-width="290"> -->
            <v-card>
                <v-card-title class="title noshadow pr-0">
                    <div redcolor font18><v-icon class="redcolor mr-3">warning</v-icon>Data Backup is Pending</div>
                    <div font12 class="pt-2" style="padding-left: 42px;" v-if="$root.lastBackupDate">Last Backup: {{ $root.lastBackupDate | moment("DD-MMM-YYYY hh:mm a")}}</div>
                </v-card-title>
                <v-card-text class="pt-0 font16">
                    <div light-opacity-color class="pt-2 pb-2 mb-3" style="background-color: aliceblue;margin: 0px -16px;padding-left:16px;">Backup now and ensure:</div>
                    <!-- <div font12 ligh-opacity-color class="pb-3 center-align">Last Backup: {{ $root.lastBackupDate | moment("DD-MMM-YYYY hh:mm a")}}</div> -->
                    <!-- <div center-align><v-chip font12 small class="mb-3">Last Backup: {{ $root.lastBackupDate | moment("DD-MMM-YYYY hh:mm a")}}</v-chip></div> -->
                    <ul style="line-height: 24px;list-style-type: '\2713   ';">
                        <li class="mb-3"><strong>Data Protection:</strong> <span greencolor font-medium>Safeguards</span> against any data loss.</li>
                        <li class="mb-3"><strong>Peace of Mind:</strong> <span primary-color font-medium>Data Safety</span> reassurance.</li>
                        <li><strong>Easy Access:</strong> Facilitates quick data <span primary-color font-medium>Restoration</span>.</li>
                    </ul>
                    <!-- <div light-opacity-color font12 class="pt-3 center-align">Last Backup: {{ $root.lastBackupDate | moment("DD-MMM-YYYY hh:mm a")}}</div> -->
                </v-card-text>
                <v-card-actions style="padding:6px 0px;">
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 center-align pl-3 pr-3>
                            <v-btn font-heavy color="primary" block @click="fn_dataBackup">Backup Now</v-btn>
                        </v-flex>
                        <v-flex xs12 sm12 md12 center-align pl-3 pr-3 mt-3>
                            <v-btn font-heavy flat color="primary" outline block @click="$root.fn_whatsAppSupport">Contact Support</v-btn>
                        </v-flex>
                        <v-flex xs12 sm12 md12 center-align pl-3 pr-3 mt-3>
                            <v-btn font-heavy light-opacity-color flat block @click="fn_close(false)">Later</v-btn>
                        </v-flex>
                        <!-- <v-flex xs12 sm12 md12 center-align pl-3 pr-3 mt-3 v-if="!appOpenCount || (appOpenCount && appOpenCount <= 4)">
                            <v-btn font-heavy light-opacity-color flat block @click="fn_close">Later</v-btn>
                        </v-flex> -->
                    </v-layout>
                </v-card-actions>
            </v-card>
        <!-- </v-dialog> -->
        </v-bottom-sheet>
    </div>
</template>

<script>
export default{
	props:['gotoDataBackup', 'skipAlert', 'appOpenCount'],
	data(){	
		return{
			dialogBackupData: false,
            hideNavigation:false
		}
	},
	methods: {
		openDialogWeb: function () {	
            // if(localStorage.getItem('bottom_navigation_index')){
            //     this.$root.fn_hideNavigation();
            // }
			this.dialogBackupData = true;
		},
		closeDialogWeb: function () {
            // if(localStorage.getItem('data_alert')){
            //     localStorage.removeItem('data_alert');
            //     let tabIndex = localStorage.getItem('bottom_navigation_index') ? localStorage.getItem('bottom_navigation_index') : 1003;
            //     this.$root.fn_showNavigation('alert', Number(tabIndex));
            // }
            this.dialogBackupData = false;
		},
        fn_close: function(doNotSkip){
            if(this.skipAlert && !doNotSkip){
                this.skipAlert();
            }
            else{
                this.closeDialogWeb();
            }
        },
        fn_dataBackup: function(){
            if(this.appOpenCount && this.appOpenCount>4){
                this.closeDialogWeb();
                window.js_globals.fn_onBackPress = window.js_globals.fn_onBackPressPrevious;
                this.$router.push({path:"/settings/backup", query:{"auto_start":1, exitapp:1}});
            }
            else{
                this.fn_close(1);
                this.$router.push({path:"/settings/backup", query:{"auto_start":1}});
            }
            
        },
		// fn_watchHelpVideo: function(){
		// 	this.$root.fn_openExternalUrl('https://www.youtube.com/watch?v=Swi0dXEjHKk&list=PLlyT7aaJmsIsicHYhxa_JWGHA0RK41yuh');
		// },
        // fn_redirectToWhatsApp: function(){
        //   this.$root.fn_openExternalUrl("https://api.whatsapp.com/send?phone=918882741212");
        // },
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_data_backup.vue